// extracted by mini-css-extract-plugin
export default {"wrapper":"PageWrapper_wrapper__07LV8","light":"PageWrapper_light__ck+Np","dark":"PageWrapper_dark__IL9Dg"};